import React, { CSSProperties } from 'react'
import { Tag } from '@blueprintjs/core'
import { Button, Flex, IconButton } from '@ui'

interface IProps {
  filterCount: number
  onClick?: () => void
  style?: CSSProperties
  className?: string
  onClear?: () => void
}

export default function FilterButton({ filterCount, onClick, style, className, onClear }: IProps) {
  return (
    <div className="f">
      <Button
        data-button="filter-button"
        iconName="filter"
        onClick={onClick}
        style={{ ...style }}
        className={className}
        text={
          <Flex align="center">
            Filter
            {filterCount > 0 && (
              <Tag
                round
                minimal
                style={{
                  marginLeft: 8,
                  background: 'var(--primary-color)',
                  color: 'var(--white)',
                }}
              >
                {filterCount}
              </Tag>
            )}
          </Flex>
        }
      />
      {Boolean(filterCount && onClear) && (
        <span className="ml2">
          Clear filters
          {Boolean(onClear) && <IconButton minimal iconName="times" onClick={onClear} />}
        </span>
      )}
    </div>
  )
}
